import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import firebase from 'firebase/app';
import { Http } from '@angular/http';
import { AngularFirestore } from 'angularfire2/firestore';
import html2canvas from 'html2canvas';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
//import * as jsPDF from 'jspdf'
import { LoadingProvider } from '../../providers/loading/loading';
//import { empty } from 'rxjs';
import { ContactFormService } from '../edit-contact-form-list/services/contact-form.service';
import { EnvDataService } from '../../app/services/env-data-service';
@Component({
  selector: 'show-view-contact-pdf',
  templateUrl: 'show-contact-pdf.html',
  providers: [EnvDataService,ContactFormService]
})
export class ShowContactPdfPage {
  public usersDetails : any;
  public contact_uid: any;
  public singleUserDetails: any;
  public unique_key: any;
  public user_data: any;
  public employment: any;
  public secondary_user_datas: any;
  public secondary_user_employment: any;
  public secondary_user_employment_datas: any;
  public realestates: any;
  public tentativerealestates: any;
  public total_current_balance: any;
  public total_mortgage_limit: any;
  public total_asset_value: any;
  public total_available_redraw: any;
  public total_repayments: any;
  public total_annual_repayments_limit: any;
  public total_gross_amount: any;
  public total_rent_annual: any;
  public total_lvr: any;
  public total_tentative_current_balance : any;
  public total_tentative_current_balance1 : any;
  public total_tentative_mortgage_limit : any;
  public total_tentative_mortgage_limit1 : any;
  public total_tentative_asset_value : any;
  public total_tentative_asset_value1 : any;
  public total_tentative_available_redraw : any;
  public total_tentative_available_redraw1 : any;
  public total_tentative_repayments : any;
  public total_tentative_repayments1 : any;
  public total_tentative_annual_repayments_limit : any;
  public total_tentative_annual_repayments_limit1 : any;
  public total_tentative_gross_amount : any;
  public total_tentative_gross_amount1 : any;
  public total_tentative_rent_annual : any;
  public total_tentative_rent_annual1 : any;
  public total_tentative_lvr : any;
  public total_tentative_lvr1 : any;
  public pdfMake: any;
  public contentDataURL: any;
  public pdfDoc: any;
  public t_document_id: any;
  public userRole: any;
  public assets: any;
  public liabilities: any;
  public incomes: any;
  public address:any;
  public showHideTentativetable : any = false;
  public showHideTentativetableIcon : any = 'apps';
  public showHideRealtable : any = false;
  public showHideRealtableIcon : any = 'apps';

  public annual_repayments_limit1:any;
  public annual_repayments_limit2:any;
  public realestateSplits: any;
  public split_current_balance : any;
  public split_mortgage_limit : any;
  public split_available_redraw: any;
  public split_repayments : any;
  public split_interest_rate : any;
  public split_creditor : any;
  public split_interest_rate_term : any;
  public split_loan_type : any;
  public split_tentative_creditor : any;
  public split_tentative_interest_rate_term : any;
  public split_tentative_loan_type : any;
  public tentative_annual_repayments_limit1:any;
  public tentative_annual_repayments_limit2:any;
  public tentative_realestateSplits: any;
  public split_tentative_current_balance : any;
  public split_tentative_mortgage_limit : any;
  public split_tentative_repayments : any;
  public split_tentative_interest_rate : any;
  public primary_secondary_found: any;
  public grid: any;
  public gridHeight: any;
  public SDF_form_document_id: any;
  public secondary_applicant: any;
  public showdetails:any;
  public dependent:any;
  user_data_load=false;
  public assigned_broker_name: any;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http : Http,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    private ContactFormService: ContactFormService,
  ) {
    this.incomes = [];
    this.assets = [];
    this.liabilities = [];

    this.realestates = '';
    this.tentativerealestates = '';

    this.secondary_user_datas = [];
    this.user_data = '';
    this.employment = '';
    let thiss = this;
    this.total_tentative_current_balance1 = [];
    this.total_tentative_mortgage_limit1 = [];
    this.total_tentative_asset_value1 = [];
    this.total_tentative_available_redraw1 = [];
    this.total_tentative_repayments1 = [];
    this.total_tentative_annual_repayments_limit1 = [];
    this.total_tentative_gross_amount1 = [];
    this.total_tentative_rent_annual1 = [];
    this.total_tentative_lvr1 = [];
    this.userRole = window.localStorage.getItem("userRole");

    if(this.userRole == 'broker' || this.userRole == 'super_admin' || this.userRole == 'loan_admin'){
      this.contact_uid = this.navParams.get("contact_uid");
      //this.t_document_id = this.navParams.get("t_document_id");
      //this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    }else{
      this.contact_uid = location.search.split('id=')[1];
      //this.t_document_id = location.search.split('&docId=')[1];
      // if(this.t_document_id != undefined){
      //   this.contact_uid = this.contact_uid.split('&docId=')[0];
      // }
    }

    if(thiss.SDF_form_document_id != undefined){

      let SDF_form = firebase.firestore().collection("SDF_form").doc(thiss.SDF_form_document_id);
      SDF_form.get().then(function(SDF_form_doc) {
        if (SDF_form_doc.exists) {
          let sdf_data = SDF_form_doc.data();
          let main_uid = sdf_data.uid;
          let docRef1 = firebase.firestore().collection("users").doc(main_uid);
          docRef1.get().then(function(doc) {
            if (doc.exists) {
              thiss.user_data = doc.data();
              thiss.get_user_data(main_uid, thiss.SDF_form_document_id).subscribe((get_user_data)=>{
                if(get_user_data.length > 0){
                  thiss.user_data = get_user_data[0];
                  thiss.user_data.accessGrantedFromUser = get_user_data[0].accessGrantedFromUser;
                  thiss.user_data.email = doc.data().email;
                  thiss.user_data.mobile_phone = doc.data().mobile_phone;
                  firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", main_uid).get()
                  .then(function(querySnapshot2) {
                    querySnapshot2.forEach(function(empDoc) {
                      thiss.employment = empDoc.data();
                    });
                  })
                  thiss.get_second_user_data(thiss.SDF_form_document_id).subscribe((get_second_user_data)=>{
                    if(get_second_user_data.length > 0){
                      thiss.secondary_applicant = [];
                      Object.keys(get_second_user_data).forEach(function(key) {
                        var secondUser = firebase.firestore().collection("users").doc(get_second_user_data[key].uid);
                        secondUser.get().then(function(secdoc) {
                          if (secdoc.exists) {
                            firebase.firestore().collection("employment").where("SDF_form", "==", thiss.SDF_form_document_id).where("uid", "==", get_second_user_data[key].uid).get()
                            .then(function(querySnapshotEmp) {
                              querySnapshotEmp.forEach(function(empDoc1) {
                                thiss.secondary_applicant.push({'employment': empDoc1.data(), 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
                              })
                              if(querySnapshotEmp.empty){
                                thiss.secondary_applicant.push({'employment': [], 'second_user_data': get_second_user_data[key], 'email': secdoc.data().email, 'mobile_phone': secdoc.data().mobile_phone});
                              }
                            });
                          }
                        });
                      })
                    }
                  });
                }
              });
              thiss.get_incomes(sdf_data.id).subscribe((get_incomes)=>{
                if(get_incomes.length > 0){
                  thiss.incomes = get_incomes
                  Object.keys(get_incomes).forEach(function(key) {
                    thiss.get_owner(get_incomes[key].SDF_form, get_incomes[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.incomes[key].firstname = get_owner[0].firstname;
                        thiss.incomes[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_assets(sdf_data.id).subscribe((get_assets)=>{
                if(get_assets.length > 0){
                  thiss.assets = get_assets
                  Object.keys(get_assets).forEach(function(key) {
                    thiss.get_owner(get_assets[key].SDF_form, get_assets[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.assets[key].firstname = get_owner[0].firstname;
                        thiss.assets[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_liabilities(sdf_data.id).subscribe((get_liabilities)=>{
                if(get_liabilities.length > 0){
                  thiss.liabilities = get_liabilities
                  Object.keys(get_liabilities).forEach(function(key) {
                    thiss.get_owner(get_liabilities[key].SDF_form, get_liabilities[key].uid).subscribe((get_owner)=>{
                      if(get_owner.length > 0){
                        thiss.liabilities[key].firstname = get_owner[0].firstname;
                        thiss.liabilities[key].lastname = get_owner[0].lastname;
                      }
                    });
                  })
                }
              });
              thiss.get_realEstates(sdf_data.id).subscribe((get_realEstates)=>{
                if(get_realEstates.length > 0){
                  thiss.total_current_balance = parseInt('0');
                  thiss.total_mortgage_limit = parseInt('0');
                  thiss.total_asset_value = parseInt('0');
                  thiss.total_available_redraw = parseInt('0');
                  thiss.total_repayments = parseInt('0');
                  thiss.total_annual_repayments_limit = parseInt('0');
                  thiss.total_gross_amount = parseInt('0');
                  thiss.total_rent_annual = parseInt('0');
                  thiss.total_lvr = parseInt('0');
                  thiss.realestateSplits = [];
                  let showHideLeaderCreditorRealestate = [];
                  let showHideLeaderMortgageLimitRealestate = [];
                  let showHideLeaderCurrentBalanceRealestate = [];
                  let showHideLeaderIntrestRateRealestate = [];
                  let showHideLeaderInterestRateTermRealestate = [];
                  let showHideLeaderLoanTypeRealestate = [];
                  let showHideLeaderRepaymentsRealestate = [];

                  thiss.realestates = get_realEstates;
                  get_realEstates.forEach(function (value, index) {
                    thiss.split_current_balance = parseInt('0');
                    thiss.split_mortgage_limit = parseInt('0');
                    thiss.split_available_redraw = parseInt('0');
                    thiss.split_repayments = parseInt('0');
                    thiss.annual_repayments_limit1 = parseInt('0');
                    thiss.annual_repayments_limit2 = parseInt('0');
                    thiss.split_interest_rate = parseFloat('0');
                    if(value.split.length > 0){
                      showHideLeaderCreditorRealestate = [];
                      showHideLeaderMortgageLimitRealestate = [];
                      showHideLeaderCurrentBalanceRealestate = [];
                      showHideLeaderIntrestRateRealestate = [];
                      showHideLeaderInterestRateTermRealestate = [];
                      showHideLeaderLoanTypeRealestate = [];
                      showHideLeaderRepaymentsRealestate = [];
                      value.split.forEach(function (value2, key2) {
                        showHideLeaderCreditorRealestate.push(0);
                        showHideLeaderMortgageLimitRealestate.push(0);
                        showHideLeaderCurrentBalanceRealestate.push(0);
                        showHideLeaderIntrestRateRealestate.push(0);
                        showHideLeaderInterestRateTermRealestate.push(0);
                        showHideLeaderLoanTypeRealestate.push(0);
                        showHideLeaderRepaymentsRealestate.push(0);
                        thiss.split_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        thiss.split_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                        thiss.split_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                        thiss.split_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
                        thiss.split_interest_rate += parseFloat(value2.interest_rate);
                        thiss.split_creditor = value2.creditor;
                        thiss.split_loan_type = value2.loan_type;
                        thiss.split_interest_rate_term = value2.interest_rate_term;

                        let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        let IR = parseFloat(value2.interest_rate);

                        thiss.annual_repayments_limit1 += ((CB)*(IR/100));

                        thiss.realestates[index].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                        thiss.realestates[index].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                        thiss.realestates[index].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                        thiss.realestates[index].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
                      });

                      thiss.realestates[index].creditor = thiss.split_creditor;
                      thiss.realestates[index].interest_rate_term = thiss.split_interest_rate_term;
                      thiss.realestates[index].loan_type = thiss.split_loan_type;
                      thiss.realestates[index].mortgage_limit = thiss.split_mortgage_limit;
                      thiss.realestates[index].available_redraw = thiss.split_available_redraw;
                      thiss.realestates[index].current_balance = thiss.split_current_balance;
                      thiss.realestates[index].repayments = thiss.split_repayments;
                      thiss.realestates[index].interest_rate = thiss.split_interest_rate;
                      //thiss.realestates[index].available_redraw = thiss.split_mortgage_limit - thiss.split_current_balance;
                      thiss.realestates[index].lvr = ((thiss.split_current_balance/parseInt(value.asset_value))*100).toFixed(2);

                      thiss.total_current_balance += parseInt(thiss.split_current_balance);
                      thiss.total_mortgage_limit += parseInt(thiss.split_mortgage_limit);
                      thiss.total_asset_value += parseInt(value.asset_value);
                      thiss.total_available_redraw += parseInt(thiss.split_available_redraw);
                      //thiss.total_available_redraw += parseInt(thiss.split_mortgage_limit) - parseInt(thiss.split_current_balance);
                      thiss.total_repayments += parseInt(thiss.split_repayments);
                      thiss.total_gross_amount += parseInt(value.gross_amount);
                      thiss.total_rent_annual += parseInt(value.rent_annual);
                      thiss.realestates[index].lvr = ((parseInt(thiss.split_current_balance)/parseInt(value.asset_value))*100).toFixed(2);
                      thiss.annual_repayments_limit1 = (parseInt(thiss.split_current_balance)*(parseFloat(thiss.split_interest_rate)/100)).toFixed(2);
                      thiss.annual_repayments_limit2 = (parseInt(thiss.split_current_balance)*12).toFixed(2);
                      if(parseInt(thiss.annual_repayments_limit1) > parseInt(thiss.annual_repayments_limit2)){
                        thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit1);
                        thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit1);
                      }else{
                        thiss.total_annual_repayments_limit += parseInt(thiss.annual_repayments_limit2);
                        thiss.realestates[index].annual_repayments_limit = parseInt(thiss.annual_repayments_limit2);
                      }
                      thiss.total_lvr = ((thiss.total_current_balance/thiss.total_asset_value)*100).toFixed(2);
                    }
                  });
                }
              });

              if(thiss.user_data.how_many_children > 0){}else{
                thiss.user_data.how_many_children = 0;
              }

            }
          });
        }

      }).catch(function(error) {
        console.log("Error getting document:", error);
      });

      thiss.getAllTentativeRealEstates().subscribe((tdata)=>{
        if(tdata.length > 0){
          thiss.tentativerealestates = [];
          thiss.showHideTentativetable = [];
          let group_id = parseInt('0');

          let showHideLeaderAddressTentaRealestate = [];
          let showHideLeaderAssetValueTentaRealestate = [];
          let showHideLeaderOwnershipTitleTentaRealestate = [];
          let showHideLeaderCreditorTentaRealestate = [];
          let showHideLeaderMortgageLimitTentaRealestate = [];
          let showHideLeaderCurrentBalanceTentaRealestate = [];
          let showHideLeaderIntrestRateTentaRealestate = [];
          let showHideLeaderInterestRateTermTentaRealestate = [];
          let showHideLeaderLoanTypeTentaRealestate = [];
          let showHideLeaderRepaymentsTentaRealestate = [];
          let showHideLeaderGrossAmountTentaRealestate = [];

          tdata.forEach(function (value, key) {

            if(value.group_id != group_id){

              showHideLeaderAddressTentaRealestate = [];
              showHideLeaderAssetValueTentaRealestate = [];
              showHideLeaderOwnershipTitleTentaRealestate = [];
              showHideLeaderCreditorTentaRealestate = [];
              showHideLeaderMortgageLimitTentaRealestate = [];
              showHideLeaderCurrentBalanceTentaRealestate = [];
              showHideLeaderIntrestRateTentaRealestate = [];
              showHideLeaderInterestRateTermTentaRealestate = [];
              showHideLeaderLoanTypeTentaRealestate = [];
              showHideLeaderRepaymentsTentaRealestate = [];
              showHideLeaderGrossAmountTentaRealestate = [];

              let totalECB = parseInt('0');
              let totalCB = parseInt('0');
              let totalML = parseInt('0');
              let totalAA = parseInt('0');
              let totalMR = parseInt('0');
              let totalARL = parseInt('0');
              let totalRIW = parseInt('0');
              let totalRA = parseInt('0');
              let totalLVR = '';

              var groupData = thiss.getDimensionsByFilter(value.group_id, tdata);

              groupData.forEach(function (value1, key1) {

                let showHideLeaderCreditorTentaRealestateSplit = [];
                let showHideLeaderMortgageLimitTentaRealestateSplit = [];
                let showHideLeaderCurrentBalanceTentaRealestateSplit = [];
                let showHideLeaderIntrestRateTentaRealestateSplit = [];
                let showHideLeaderInterestRateTermTentaRealestateSplit = [];
                let showHideLeaderLoanTypeTentaRealestateSplit = [];
                let showHideLeaderRepaymentsTentaRealestateSplit = [];

                let split_tentative_creditor = '';
                let split_tentative_interest_rate_term = '';
                let split_tentative_loan_type = '';
                let split_tentative_mortgage_limit = parseInt('0');
                let split_tentative_current_balance = parseInt('0');
                let split_tentative_available_redraw = parseInt('0');
                let split_tentative_repayments = parseInt('0');
                let split_tentative_interest_rate = parseInt('0');
                let annual_repayments_limit1 = parseInt('0');
                if(value1.split.length > 0){
                  value1.split.forEach(function (value2, key2) {

                    showHideLeaderCreditorTentaRealestateSplit.push(0);
                    showHideLeaderMortgageLimitTentaRealestateSplit.push(0);
                    showHideLeaderCurrentBalanceTentaRealestateSplit.push(0);
                    showHideLeaderIntrestRateTentaRealestateSplit.push(0);
                    showHideLeaderInterestRateTermTentaRealestateSplit.push(0);
                    showHideLeaderLoanTypeTentaRealestateSplit.push(0);
                    showHideLeaderRepaymentsTentaRealestateSplit.push(0);

                    split_tentative_current_balance += parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    split_tentative_mortgage_limit += parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                    split_tentative_available_redraw += parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                    split_tentative_repayments += parseInt(value2.repayments.split("$").join("").split(",").join(""));
                    split_tentative_interest_rate += parseFloat(value2.interest_rate);
                    split_tentative_creditor = value2.creditor;
                    split_tentative_loan_type = value2.loan_type;
                    split_tentative_interest_rate_term = value2.interest_rate_term;

                    let CB = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    let IR = parseFloat(value2.interest_rate);

                    annual_repayments_limit1 += ((CB)*(IR/100));

                    groupData[key1].split[key2].current_balance = parseInt(value2.current_balance.split("$").join("").split(",").join(""));
                    groupData[key1].split[key2].mortgage_limit = parseInt((value2.mortgage_limit == undefined) ? 0 : value2.mortgage_limit.split("$").join("").split(",").join(""));
                    groupData[key1].split[key2].available_redraw = parseInt((isNaN(value2.available_redraw)) ? value2.available_redraw.split("$").join("").split(",").join("") : value2.available_redraw);
                    groupData[key1].split[key2].repayments = parseInt(value2.repayments.split("$").join("").split(",").join(""));
                  });
                }

                groupData[key1].creditor = split_tentative_creditor;
                groupData[key1].interest_rate_term = split_tentative_interest_rate_term;
                groupData[key1].loan_type = split_tentative_loan_type;
                groupData[key1].mortgage_limit = split_tentative_mortgage_limit;
                groupData[key1].current_balance = split_tentative_current_balance;
                groupData[key1].available_redraw = split_tentative_available_redraw;
                groupData[key1].repayments = split_tentative_repayments;
                groupData[key1].interest_rate = split_tentative_interest_rate;
                groupData[key1].available_redraw = split_tentative_mortgage_limit - split_tentative_current_balance;
                groupData[key1].lvr = ((split_tentative_current_balance/parseInt(value1.asset_value))*100).toFixed(2);


                totalECB += parseInt(value1.asset_value);
                totalCB += split_tentative_current_balance;
                totalML += split_tentative_mortgage_limit;
                totalAA += split_tentative_available_redraw;
                totalMR += split_tentative_repayments;
                totalRIW += parseInt(value1.gross_amount);
                totalRA += parseInt(value1.rent_annual);
                totalLVR = ((totalCB/totalECB)*100).toFixed(2);

                let annual_repayments_limit2 = (totalMR*12).toFixed(2);
                if(annual_repayments_limit1 > parseInt(annual_repayments_limit2)){
                  groupData[key1].annual_repayments_limit = annual_repayments_limit1;
                  totalARL += annual_repayments_limit1;
                }else{
                  groupData[key1].annual_repayments_limit = parseInt(annual_repayments_limit2);
                  totalARL += parseInt(annual_repayments_limit2);
                }

                showHideLeaderAddressTentaRealestate.push(0);
                showHideLeaderAssetValueTentaRealestate.push(0);
                showHideLeaderOwnershipTitleTentaRealestate.push(0);
                showHideLeaderGrossAmountTentaRealestate.push(0);
                showHideLeaderCreditorTentaRealestate.push(showHideLeaderCreditorTentaRealestateSplit);
                showHideLeaderMortgageLimitTentaRealestate.push(showHideLeaderMortgageLimitTentaRealestateSplit);
                showHideLeaderCurrentBalanceTentaRealestate.push(showHideLeaderCurrentBalanceTentaRealestateSplit);
                showHideLeaderIntrestRateTentaRealestate.push(showHideLeaderIntrestRateTentaRealestateSplit);
                showHideLeaderInterestRateTermTentaRealestate.push(showHideLeaderInterestRateTermTentaRealestateSplit);
                showHideLeaderLoanTypeTentaRealestate.push(showHideLeaderLoanTypeTentaRealestateSplit);
                showHideLeaderRepaymentsTentaRealestate.push(showHideLeaderRepaymentsTentaRealestateSplit);


              });
              let splitData = [];
              splitData.push({});
              groupData.push({'current_balance' : totalCB, 'mortgage_limit' : totalML, 'asset_value' : totalECB, 'available_redraw' : totalAA, 'repayments' : totalMR, 'gross_amount' : totalRIW, 'rent_annual' : totalRA, 'lvr' : totalLVR, 'annual_repayments_limit' : totalARL.toFixed(2), 'split' : splitData});

              thiss.tentativerealestates.push(groupData);
            }
            group_id = value.group_id;
          });
        }
      });
    }
    this.contactDetails();

  }

  contactDetails(){
    this.ContactFormService.getApplicantDetails(this.navParams.get("contact_uid")).then((data:any) => {
      this.showdetails = data;
      this.user_data = data.user_data;
      this.dependent = data.contact_details.dependent;
      this.employment = data.contact_details.employment_details==undefined?[]:data.contact_details.employment_details;
      this.incomes = data.contact_details.employment_details.incomes==undefined?[]:data.contact_details.employment_details.incomes;
      this.address = data.contact_details.address;
      this.user_data_load =true;
      console.log('show contact from list', this.showdetails);
      let reference_broker = this.showdetails.user_data.reference_broker;
      if(reference_broker == "" || reference_broker == null || reference_broker == undefined){}else{
      this.getBrokerDetails(reference_broker).subscribe((brokerDetails)=>{
        if(brokerDetails.length > 0){
          this.assigned_broker_name = brokerDetails[0].firstname +' '+ brokerDetails[0].lastname;
        }else{
          this.assigned_broker_name = 'Broker not assigned';
        }
      });
    }
    });
  }

  getBrokerDetails (reference_broker){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',reference_broker ).where('deleted','<',1 )).valueChanges ();
  }

  /*Primary contact incomes*/
  getPrimaryIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Primary contact assets*/
  getPrimaryAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Primary contact liabilities*/
  getPrimaryLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact*/
  getSecondaryContact (){
    return this.db.collection<any>( "users" , ref => ref.where('main_contact_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact employment*/
  getSecondaryEmployment (){
    return this.db.collection<any>( "employment" , ref => ref.where('uid','==',this.secondary_user_employment )).valueChanges ();
  }

  /*Secondary contact incomes*/
  getSecondaryIncomes (){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact assets*/
  getSecondaryAssets (){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  /*Secondary contact liabilities*/
  getSecondaryLiabilities (){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',this.secondary_user_employment ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstates (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstatesS (){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('secondary_uid','==',this.contact_uid ).where('deleted','<',1 )).valueChanges ();
  }

  getAllRealEstateSplits (document_id){
    return this.db.collection<any>( "SDF_realestate/"+document_id+'/mortgage_splits' , ref => ref.where('deleted','<',1 )).valueChanges ();
  }

  getAllTentativeRealEstates (){
    return this.db.collection<any>( "tentative_real_estate" , ref => ref.where('group_id','==',this.t_document_id ).where('deleted','==',0 )).valueChanges ();
  }

  get_user_data (contact_uid, SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid).where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','<',1 )).valueChanges ();
  }

  get_second_user_data (SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('created_date','>',0 ).where('contact_type','==','Secondary Contact').where('SDF_form_document_id','==',SDF_form_document_id).where('deleted','==',0 ).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_SDF_form (SDF_form_document_id){
    return this.db.collection<any>( "SDF_form" , ref => ref.where('id','==',SDF_form_document_id)).valueChanges ();
  }

  get_incomes (SDF_form_document_id){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_assets (SDF_form_document_id){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_liabilities (SDF_form_document_id){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_realEstates (SDF_form_document_id){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('created_date','>',0 ).where('SDF_form','==',SDF_form_document_id).where('deleted','==',0).orderBy('created_date', 'asc')).valueChanges ();
  }

  get_owner (SDF_form_document_id, uid){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id).where('uid','==',uid).where('deleted','<',1)).valueChanges ();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ViewContactPdfPage');
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
    } catch (e) {
      console.log(e)
    }
  }

  downloadPdf(customName){

    html2canvas(document.getElementById('content'), {allowTaint: true}).then(canvas => {
      var thiss = this;
      //primary contact
      var full_name = this.user_data.firstname +' '+ this.user_data.lastname;
      var address = this.address[0].street_number+' '+this.address[0].street_name+' '+this.address[0].city+' '+this.address[0].state+' '+this.address[0].country+' '+this.address[0].postcode;
      var how_many_children = 'No';
      if(this.user_data.how_many_children > 0){
        how_many_children = this.user_data.how_many_children;
      }
      var primaryValue = [];
      var value1 = [];
      value1.push({text: 'Personal Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      value1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, true, true], borderColor:['','','#fff','#fff']});
      value1.push({text: 'Employment Details', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      value1.push({text: '', style: 'primaryPersonalEmploymenttitleMain', border: [false, false, false, true], borderColor:['','','','#fff']});
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Full Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: full_name, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: 'Type of Employment : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.employment.employementType, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Email : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.email, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      if(this.employment.employementType == 'payg'){
        value1.push({text: 'Currently Employed : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.currentlyEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Business Name : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.business_name, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];
      value1.push({text: 'Phone Number : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.mobile_phone, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'yes'){
        value1.push({text: 'Currently Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.statusyourEmployment, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'no'){
        value1.push({text: 'In how long do you expect to find work? : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.expectFindWork, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Type of Entity : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.type_of_entity, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Date of Birth : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.user_data.date_of_birth, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});

      if(this.employment.employementType == 'payg' && this.employment.currentlyEmployment == 'yes'){
        value1.push({text: 'Your Occupation', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.your_occupation, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'ABN/ACN', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Address : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: address, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});

      if(this.employment.employementType == 'self-employed'){
        value1.push({text: 'Nature of Business', style: 'primaryDetailsMain', border: [false, false, false, false]});
        value1.push({text: this.employment.abn_acn, style: 'primaryDetails', border: [false, false, false, false], alignment: 'right'});
      }else{
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
        value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      }
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'Marital Status : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: this.dependent.current_marital_status, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      primaryValue.push(value1);
      value1 = [];

      value1.push({text: 'How Many Children : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
      value1.push({text: how_many_children, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
      primaryValue.push(value1);

      if(this.dependent.how_many_children > 0){
        if(this.dependent.first_child_age > 0){
          value1 = [];
          value1.push({text: 'First Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.first_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.dependent.second_child_age > 0){
          value1 = [];
          value1.push({text: 'Second Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.second_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.dependent.third_child_age > 0){
          value1 = [];
          value1.push({text: 'Third Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.third_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.dependent.fourth_child_age > 0){
          value1 = [];
          value1.push({text: 'Fourth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.fourth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.dependent.fifth_child_age > 0){
          value1 = [];
          value1.push({text: 'Fifth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.fifth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }

        if(this.dependent.sixth_child_age > 0){
          value1 = [];
          value1.push({text: 'Sixth Child Age : ', style: 'primaryDetailsMain', border: [false, false, false, false]});
          value1.push({text: this.dependent.sixth_child_age, style: 'primaryDetails', border: [false, false, true, false], borderColor:['','','#fff',''], alignment: 'right'});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          value1.push({text: '', style: 'primaryDetails', border: [false, false, false, false]});
          primaryValue.push(value1);
        }
      }

      //end primary contact

      //secondary contact
      var secondvalue1 = [];


      //income section
      var incomesColumn = [];
      var incomesValue = [];
      var incomesData = [];
      incomesColumn.push({text: 'Type', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Contact', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Amount', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Frequency',style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Date', style: 'primaryIAL', border: [false, false, false, false]});
      incomesColumn.push({text: 'Comments', style: 'primaryIAL', border: [false, false, false, false]});
      incomesData.push(incomesColumn);
      if(this.incomes.length > 0){
        for(var i = 0; i < this.incomes.length; i++){
          incomesValue = [];
          incomesValue.push({text: this.incomes[i].type, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.user_data.firstname+' '+this.user_data.lastname, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].amount, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].frequency, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].date_commenced, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesValue.push({text: this.incomes[i].comments, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
          incomesData.push(incomesValue);
        }
      }
      //return false;

      if(this.incomes.length == 0){
        incomesValue = [];
        incomesValue.push({text: 'There are no incomes.',colSpan: 6, style: 'primaryPersonalEmploymenttitle', border: [false, false, false, false]});
        incomesData.push(incomesValue);
      }
      //end income section

      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      this.pdfDoc = {
        //pageSize: {width: 575, height: 850},
        pageSize: 'A4',
        pageMargins: [20, 30, 20, 30],
        dontBreakRows: true,
        content: [
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Primary Contact Details', style: 'primary', border: [false, false, false, false]}]
              ]
            },
            layout: {
              hLineColor: function(i, node) {
                return '#29718c';
              },
              vLineColor: function(i, node) {
                return '#29718c';
              }
            }
          },
          {
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: primaryValue
            },
            layout: {
              vLineWidth: function(i, node) {
                return 5;
              }
            }
          },
          {
            table: {
              widths: ['100%'],
              body: [
                [{text: 'Income Details', border: [false, false, false, false], margin: [0,20,0,0], bold: true}]
              ]
            }
          },
          {
            table: {
              widths: ['10%', '10%', '15%','15%', '20%', '30%'],
              body: incomesData
            }
          },

          {
            table: {
              widths: ['100%'],
              body: [
                [{text: '', border: [false, false, false, false], margin: [0,0,0,20]}]
              ]
            }
          },
        ],
        styles: {
          header: {
            fontSize: 10,
            bold: true,
            margin: [0, 0, 0, 10],
            borderRadius: [5, 5, 5, 5]
          },
          subheader: {
            fontSize: 10,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          primaryPersonalEmploymenttitleMain: {
            bold: true,
            fillColor: '#fff'
          },
          primaryPersonalEmploymenttitle: {
            margin: [0, 5, 0, 5],
            fontSize: 10,
            fillColor: '#f7f7f7'
          },primaryDetailsMain: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#f7f7f7',
            bold: true
          },
          primaryDetails: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#f7f7f7'
          },
          realEstateSplitTitle: {
            fontSize: 11,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee',
            bold: true
          },
          realEstateSplit1: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee',
            bold: true
          },
          realEstateSplit: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#eeeeee'
          },
          primaryIAL: {
            bold: true,
            fontSize: 10,
            color: 'white',
            fillColor:'#195f79',
            border: [false, false, false, false],
            alignment: 'left',
            margin: [5, 5, 5, 5]
          },
          totalWithImage: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor:'#dbeef4'
          },
          totalWithImageMain: {
            fontSize: 10,
            margin: [0, 2, 0, 2],
            fillColor: '#dbeef4',
            bold: true
          },
          primary: {
            bold: true,
            fontSize: 12,
            color: 'white',
            fillColor:'#195f79',
            border: [false, false, false, false],
            alignment: 'left',
            margin: [5, 5, 5, 5]
          },
          tableViewTentativeText: {
            fontSize: 6
          },
          tableViewTentativeText1: {
            fontSize: 6,
            fillColor:'#195f79',
            color: 'white', bold: true,
            hLineColor:['#fff','#fff','#fff','#fff']
          },
          customerTag: {
            fillColor:'#195f79',
            color: 'white', bold: true,
            fontSize: 10,
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      }
      //return false;
      let d = new Date(); // for now
      let pdfName = d.getDate() + "-" + (d.getMonth()+1) + "-" + d.getFullYear();
      if(this.user_data.firstname == "" || this.user_data.firstname == null || this.user_data.firstname == undefined){}else{
        pdfName += ' - '+this.user_data.firstname+' '+this.user_data.lastname;
      }

      // if(customName != undefined && customName.length > 0){
      //   pdfName += ' '+customName[0].firstname+' '+customName[0].lastname;
      // }
      //pdfName += '.pdf';
      pdfMake.createPdf(this.pdfDoc).download(pdfName+'.pdf');
    });


  }

  getDimensionsByFilter(group_id, data){
    return data.filter(x => x.group_id === group_id);
  }

  hideShowTableListView(status){
    if(status){
      this.showHideTentativetable = false;
      this.showHideTentativetableIcon = 'apps';
    }else{
      this.showHideTentativetable = true;
      this.showHideTentativetableIcon = 'add';
    }
  }

  

  hideShowTableListViewReal(status){
    if(status){
      this.showHideRealtable = false;
      this.showHideRealtableIcon = 'apps';
    }else{
      this.showHideRealtable = true;
      this.showHideRealtableIcon = 'add';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/show-contact-pdf/show-contact-pdf.ts